import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon, CheckCircleIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "wwfxs1p";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const modalContentIsTabletUpCss = "m9mjzup";
const modalContentIsPhoneCss = "m1e5sj9u";
const modalContentCss = "msuqn54";
export const ModalContent = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(modalContentCss, {
    [modalContentIsTabletUpCss]: isTabletUp,
    [modalContentIsPhoneCss]: isPhone
  }, props.className)} />;
});
const contentContainerIsPhoneCss = "c1urz91j";
const contentContainerCss = "cgi2b83";
export const ContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(contentContainerCss, {
    [contentContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const headingContainerCss = "h1ayc49d";
export const HeadingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headingContainerCss, props.className)} />;
});
const sidebarContainerIsTabletUpCss = "s1q1ljz4";
const sidebarContainerIsPhoneCss = "s1l28rft";
const sidebarContainerIsSmallPhoneCss = "s1j98owe";
const sidebarContainerCss = "s1bfq5mv";
const SidebarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isPhone = useDeviceType('isPhone');
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(sidebarContainerCss, {
    [sidebarContainerIsTabletUpCss]: isTabletUp,
    [sidebarContainerIsPhoneCss]: isPhone,
    [sidebarContainerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const mainImageIsTabletUpCss = "ml2t9as";
const mainImageCss = "m1hg782e";
const MainImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(mainImageCss, {
    [mainImageIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const SidebarWithImage = props => {
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <SidebarContainer>
      {!isSmallPhone && <MainImage {...props} />}
    </SidebarContainer>;
};
const bulletPointContainerCss = "b1cav1zz";
const BulletPointContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bulletPointContainerCss, props.className)} />;
});
const iconContainerCss = "iwiq3yw";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
export const BulletPoint = props => <BulletPointContainer>
    <IconContainer>
      <CheckCircleIcon spacingRight={8} />
    </IconContainer>
    {props.children}
  </BulletPointContainer>;
const closeIconButtonCss = "c5kc4ap";
const CloseIconButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(closeIconButtonCss, props.className)} />);
export const CloseButton = props => <CloseIconButton size="small" title={I18n.t('publisher.action.close')} onClick={props.onClick}>
    <CloseIcon />
  </CloseIconButton>;

require("./shared.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared.js");